module.exports = __webpack_public_path__ + "img/Manta.1cbd297e.png";